/* eslint-disable @typescript-eslint/no-require-imports */
import { Platform } from 'react-native';

const DownloadScreen =
  Platform.OS === 'web' ? require('./download.web').default : require('./download.native').default;

export default DownloadScreen;
